// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../../../../../writer-core-master/Product/ItSymphony.Writer.Web/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../../../../../writer-core-master/Product/ItSymphony.Writer.Web/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.channel-operators-import select {
    display: inline-block;
}

.channel-operators-import
.channel-operators-import__header-info {
    color: #cccccc;
}

.channel-operators-import
.channel-operators-import__header-bold {
    font-weight: 700;
}

.channel-operators-import__button {
    margin-left: 0.2rem !important;
    margin-right: 0.2rem !important;
}

.channel-operators-import
.channel-operators-import__button-apply {
    background-color: #d6ac17;
}

.channel-operators-import
.channel-operators-import__button-cancel {
    background-color: #d22e37;
}

.channel-operators-import
.channel-operators-import__option-active {
    background-color: #b9f6ca;
}

.channel-operators-import
.channel-operators-import__option-inactive {
    background-color: #ffcdd2;
}

.select-source-first-option {
    color: #cccccc;
}

#select-source-channel-label {
    font-size: initial;
}

#select-source-channel {
    height: 40px;
}

.select-source-option {
    font-size: large;
}

.channel-operators-import-title {
    font-size: 2.6rem;
    text-align: left;
}

.channel-operators-import .modal-body {
    height: 35rem;
}

.channel-operators-import
.channel-operators-import__header-info {
    margin-top: 15px;
}

.channel-operators-import
.channel-operators-import__header-bold {
    display: inline-block;
    max-width: 460px;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    vertical-align: bottom;
}

.channel-operators-import
.MuiAutocomplete-option {
    display: block !important;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
}

.channel-operators-import
.channel-operators-import__no-options {
    text-align: center;
}

.channel-operators-import__keep-source {
    margin-top: 15px;
}

.channel-operators-import__checkbox-label {
    display: flex !important;
    align-items: center;
    cursor: pointer;
    font-size: 1.4rem !important;
    line-height: 1.5;
}

    .channel-operators-import__checkbox-label span {
        font-size: 1.4rem !important;
        color: #757575;
    }

    .channel-operators-import__checkbox-label
    input[type="checkbox"] {
        margin-right: 0.7rem;
    }

.channel-operators-import
.MuiAutocomplete-listbox {
    overflow: visible !important;
    max-height: none !important;
}

.channel-operators-import
.MuiAutocomplete-paper {
    overflow: visible !important;
    max-height: none !important;
}

.channel-operators-import
.MuiAutocomplete-popper {
    overflow: visible !important;
}
`, "",{"version":3,"sources":["webpack://./src/app/channel/channel-main/channel-list/channel-item/channel-operator-list/channel-operator-list-configuration/channel-operator-import-popup/ChannelOperatorsImportPopup.css"],"names":[],"mappings":"AAAA;IACI,qBAAqB;AACzB;;AAEA;;IAEI,cAAc;AAClB;;AAEA;;IAEI,gBAAgB;AACpB;;AAEA;IACI,8BAA8B;IAC9B,+BAA+B;AACnC;;AAEA;;IAEI,yBAAyB;AAC7B;;AAEA;;IAEI,yBAAyB;AAC7B;;AAEA;;IAEI,yBAAyB;AAC7B;;AAEA;;IAEI,yBAAyB;AAC7B;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,iBAAiB;IACjB,gBAAgB;AACpB;;AAEA;IACI,aAAa;AACjB;;AAEA;;IAEI,gBAAgB;AACpB;;AAEA;;IAEI,qBAAqB;IACrB,gBAAgB;IAChB,gBAAgB;IAChB,mBAAmB;IACnB,uBAAuB;IACvB,sBAAsB;AAC1B;;AAEA;;IAEI,yBAAyB;IACzB,gBAAgB;IAChB,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;;IAEI,kBAAkB;AACtB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,wBAAwB;IACxB,mBAAmB;IACnB,eAAe;IACf,4BAA4B;IAC5B,gBAAgB;AACpB;;IAEI;QACI,4BAA4B;QAC5B,cAAc;IAClB;;IAEA;;QAEI,oBAAoB;IACxB;;AAEJ;;IAEI,4BAA4B;IAC5B,2BAA2B;AAC/B;;AAEA;;IAEI,4BAA4B;IAC5B,2BAA2B;AAC/B;;AAEA;;IAEI,4BAA4B;AAChC","sourcesContent":[".channel-operators-import select {\r\n    display: inline-block;\r\n}\r\n\r\n.channel-operators-import\r\n.channel-operators-import__header-info {\r\n    color: #cccccc;\r\n}\r\n\r\n.channel-operators-import\r\n.channel-operators-import__header-bold {\r\n    font-weight: 700;\r\n}\r\n\r\n.channel-operators-import__button {\r\n    margin-left: 0.2rem !important;\r\n    margin-right: 0.2rem !important;\r\n}\r\n\r\n.channel-operators-import\r\n.channel-operators-import__button-apply {\r\n    background-color: #d6ac17;\r\n}\r\n\r\n.channel-operators-import\r\n.channel-operators-import__button-cancel {\r\n    background-color: #d22e37;\r\n}\r\n\r\n.channel-operators-import\r\n.channel-operators-import__option-active {\r\n    background-color: #b9f6ca;\r\n}\r\n\r\n.channel-operators-import\r\n.channel-operators-import__option-inactive {\r\n    background-color: #ffcdd2;\r\n}\r\n\r\n.select-source-first-option {\r\n    color: #cccccc;\r\n}\r\n\r\n#select-source-channel-label {\r\n    font-size: initial;\r\n}\r\n\r\n#select-source-channel {\r\n    height: 40px;\r\n}\r\n\r\n.select-source-option {\r\n    font-size: large;\r\n}\r\n\r\n.channel-operators-import-title {\r\n    font-size: 2.6rem;\r\n    text-align: left;\r\n}\r\n\r\n.channel-operators-import .modal-body {\r\n    height: 35rem;\r\n}\r\n\r\n.channel-operators-import\r\n.channel-operators-import__header-info {\r\n    margin-top: 15px;\r\n}\r\n\r\n.channel-operators-import\r\n.channel-operators-import__header-bold {\r\n    display: inline-block;\r\n    max-width: 460px;\r\n    overflow: hidden;\r\n    white-space: nowrap;\r\n    text-overflow: ellipsis;\r\n    vertical-align: bottom;\r\n}\r\n\r\n.channel-operators-import\r\n.MuiAutocomplete-option {\r\n    display: block !important;\r\n    overflow: hidden;\r\n    white-space: nowrap;\r\n    text-overflow: ellipsis;\r\n}\r\n\r\n.channel-operators-import\r\n.channel-operators-import__no-options {\r\n    text-align: center;\r\n}\r\n\r\n.channel-operators-import__keep-source {\r\n    margin-top: 15px;\r\n}\r\n\r\n.channel-operators-import__checkbox-label {\r\n    display: flex !important;\r\n    align-items: center;\r\n    cursor: pointer;\r\n    font-size: 1.4rem !important;\r\n    line-height: 1.5;\r\n}\r\n\r\n    .channel-operators-import__checkbox-label span {\r\n        font-size: 1.4rem !important;\r\n        color: #757575;\r\n    }\r\n\r\n    .channel-operators-import__checkbox-label\r\n    input[type=\"checkbox\"] {\r\n        margin-right: 0.7rem;\r\n    }\r\n\r\n.channel-operators-import\r\n.MuiAutocomplete-listbox {\r\n    overflow: visible !important;\r\n    max-height: none !important;\r\n}\r\n\r\n.channel-operators-import\r\n.MuiAutocomplete-paper {\r\n    overflow: visible !important;\r\n    max-height: none !important;\r\n}\r\n\r\n.channel-operators-import\r\n.MuiAutocomplete-popper {\r\n    overflow: visible !important;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
